import { _ } from '@ngx-translate/core';

export const MONTHS_ARRAY = [
  { id: 1, name: _('common.constants.months.january') },
  { id: 2, name: _('common.constants.months.february') },
  { id: 3, name: _('common.constants.months.march') },
  { id: 4, name: _('common.constants.months.april') },
  { id: 5, name: _('common.constants.months.may') },
  { id: 6, name: _('common.constants.months.june') },
  { id: 7, name: _('common.constants.months.july') },
  { id: 8, name: _('common.constants.months.august') },
  { id: 9, name: _('common.constants.months.september') },
  { id: 10, name: _('common.constants.months.october') },
  { id: 11, name: _('common.constants.months.november') },
  { id: 12, name: _('common.constants.months.december') },
];

export const MONTHS: Record<number, string> = {
  0: _('common.constants.months.january'),
  1: _('common.constants.months.february'),
  2: _('common.constants.months.march'),
  3: _('common.constants.months.april'),
  4: _('common.constants.months.may'),
  5: _('common.constants.months.june'),
  6: _('common.constants.months.july'),
  7: _('common.constants.months.august'),
  8: _('common.constants.months.september'),
  9: _('common.constants.months.october'),
  10: _('common.constants.months.november'),
  11: _('common.constants.months.december'),
};

const DEFAULT_YEAR_FOR_HIDE_OLD = 2999;
export const DEFAULT_YEAR_FOR_HIDE = 1900;
export const ARRAY_YEARS_FOR_HIDE = [DEFAULT_YEAR_FOR_HIDE, DEFAULT_YEAR_FOR_HIDE_OLD];
